// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"81801958","453":"155cd8d9","455":"d40152fe","838":"cb42ff49"}[chunkId] + ".chunk.js";
};